
  <template><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16"><path fill="#525252" fill-rule="evenodd" d="M12.74 3.38a1.347 1.347 0 0 1 1.875 0l-.001.001a1.28 1.28 0 0 1-.002 1.833L7.046 12.62a1.347 1.347 0 0 1-1.875 0L1.388 8.918a1.28 1.28 0 0 1 0-1.834 1.346 1.346 0 0 1 1.874 0l2.847 2.784z" clip-rule="evenodd"/><path fill="#525252" d="M13.88 12.1h2.07v1.295h-2.07V15.6h-1.42v-2.205h-2.058V12.1h2.058V9.9h1.42z"/></svg></template>
  <style scoped>
    svg {
      display: inline-block;
      vertical-align: baseline;
      margin-bottom: -2px;
    }
  </style>